import React from 'react';
import cx from 'classnames';

import MUIDivider, { DividerProps } from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core';

import units from 'ha/theme/units';

import Row from '../Row';

const useStyles = makeStyles(() => ({
  textSeparator: {
    width: 'auto',
    flexGrow: 1,
  },
  text: {
    padding: units.yx(0, 0.3),
  },
  'kind-spaced-m': {
    margin: units.yx(1, 0),
  },
  'kind-spaced-l': {
    margin: units.yx(1.5, 0),
  },
}));

type Kind = 'spaced-m' | 'spaced-l';

interface Props {
  text?: string;
  kind?: Kind;
  // For some reason we need to explicitly define `className` prop.
  className?: string;
  dividerProps?: DividerProps;
}

const Divider: React.FC<Props> = ({
  text,
  kind,
  className,
  dividerProps = {},
  ...rest
}) => {
  const classes = useStyles();

  const divider = (
    <MUIDivider
      {...rest}
      {...dividerProps}
      className={cx(className, {
        [classes[`kind-${kind}`]]: Boolean(kind),
        [classes.textSeparator]: Boolean(text),
      })}
    />
  );

  // If there is no provided text, fall back to MUI divider
  if (!text) {
    return divider;
  }

  return (
    <Row justify="space-between" alignItems="center">
      {divider}
      <Typography className={classes.text}>{text}</Typography>
      {divider}
    </Row>
  );
};

export default Divider;
